import barSimpleBarChart from "assets/images/chart-images/simple-chart.png";
import table      from "assets/images/chart-images/table.png";
const countries = [
        {id: "%AFC-T01s", name: "table", chartImage: table, v2: "Column", disabled: false},
        {id: "%AFC-BV01s", name: "simple-bar", chartImage: barSimpleBarChart, disabled: false},
];

export default countries;
